"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UF = exports.TIPO_CONTATO_EMAIL = exports.TIPO_CONTATO_2 = exports.TIPO_CONTATO_1 = exports.RACA = exports.PROFISSAO = exports.PONTO_DE_REFERENCIA = exports.PESO = exports.PAIS = exports.PACIENTE = exports.NUMERO = exports.NOME_MAE = exports.NOME = exports.MUNICIPIO = exports.LOGRADOURO = exports.JUSTIFICATIVA = exports.IDADE = exports.GRUPO_SANGUINEO = exports.GENERO = exports.FATOR_RH = exports.EMAIL = exports.DATA_NASCIMENTO = exports.DADOS_ANTIGOS = exports.CPF = exports.CONTATO_2 = exports.CONTATO_1 = exports.CNS = exports.CEP = exports.BAIRRO = exports.ALTURA = void 0;
var PACIENTE = exports.PACIENTE = 'paciente';
var NOME = exports.NOME = 'nome';
var NOME_MAE = exports.NOME_MAE = 'nomeMae';
var RACA = exports.RACA = 'raca';
var CPF = exports.CPF = 'cpf';
var CNS = exports.CNS = 'cns';
var DATA_NASCIMENTO = exports.DATA_NASCIMENTO = 'dataNascimento';
var IDADE = exports.IDADE = 'idade';
var PESO = exports.PESO = 'peso';
var ALTURA = exports.ALTURA = 'altura';
var GENERO = exports.GENERO = 'genero';
var PROFISSAO = exports.PROFISSAO = 'profissao';
var PONTO_DE_REFERENCIA = exports.PONTO_DE_REFERENCIA = 'referencia';
var LOGRADOURO = exports.LOGRADOURO = 'logradouro';
var NUMERO = exports.NUMERO = 'numero';
var BAIRRO = exports.BAIRRO = 'bairro';
var CEP = exports.CEP = 'cep';
var PAIS = exports.PAIS = 'pais';
var UF = exports.UF = 'uf';
var MUNICIPIO = exports.MUNICIPIO = 'municipio';
var TIPO_CONTATO_1 = exports.TIPO_CONTATO_1 = 'tipoContato1';
var CONTATO_1 = exports.CONTATO_1 = 'contato1';
var TIPO_CONTATO_2 = exports.TIPO_CONTATO_2 = 'tipoContato2';
var CONTATO_2 = exports.CONTATO_2 = 'contato2';
var EMAIL = exports.EMAIL = 'email';
var TIPO_CONTATO_EMAIL = exports.TIPO_CONTATO_EMAIL = 'tipoContatoEmail';
var GRUPO_SANGUINEO = exports.GRUPO_SANGUINEO = 'grupoSanguineo';
var FATOR_RH = exports.FATOR_RH = 'fatorRh';
var DADOS_ANTIGOS = exports.DADOS_ANTIGOS = 'dados_antigos';
var JUSTIFICATIVA = exports.JUSTIFICATIVA = 'justificativa';